import { atom } from 'jotai/index';
import { ConnectionState } from '../../types';

export const userStreamConnectionStateAtom = atom<ConnectionState | undefined>(undefined);
